import React from "react";
import { FormControl, TextField } from "@material-ui/core";
import InputMask from "react-input-mask";

export default function Input(props) {
  return (
    <FormControl fullWidth className={props.className}>
      <InputMask
        mask={props.mask}
        value={props.value}
        onChange={(e) => props.setValue(e)}
        onFocus={props.setErro ? () => props.setErro(null) : null}
        maskChar={props.maskChar ? props.maskChar : "_"}
        disabled={props.disabled ?? false}
      >
        {() => (
          <TextField
            id={props.id}
            label={props.label}
            color={props.color || 'primary'}
            placeholder={props.placeholder}
            size={props.size}
            variant={props.variant}
            required={props.required}
            InputLabelProps={{ shrink: true }}
            error={props.erro ? true : false}
            helperText={props.erro}
            disabled={props.disabled ?? false}
          />
        )}
      </InputMask>
    </FormControl>
  );
}
